import { useContext } from "react";

import { UserContext } from "@/contexts/user-context";
import { useBlockUser } from "@/hooks/use-block-user";
import { getUserDisplayName } from "@/utils/usernames";

import { EmptyState } from "../shared/empty-state";
import { Button } from "../ui/button";

interface FeedBlockedUserContentProps {
  onUserUnblock: (publicKey: string) => void;
  blockedUserPublicKey: string | null;
  blockedUserUsername?: string | null;
  assosiationId: string | null;
}

export const FeedBlockedUserContent = ({
  onUserUnblock,
  assosiationId,
  blockedUserPublicKey,
  blockedUserUsername,
}: FeedBlockedUserContentProps) => {
  const { user } = useContext(UserContext);
  const { unblockUser, loading } = useBlockUser();

  const onUnblockUserClick = async () => {
    if (!user?.publicKey || !blockedUserPublicKey || !assosiationId) return;

    await unblockUser(assosiationId, () => onUserUnblock(blockedUserPublicKey));
  };

  const blockedUserDisplayName = getUserDisplayName({
    username: blockedUserUsername || undefined,
    publicKey: blockedUserPublicKey || "",
  });

  return (
    <div
      className="
        flex flex-col items-center justify-center gap-4 border-y p-12 px-16
        text-center
      "
    >
      <EmptyState
        title="You are unable to view this user's posts because you have blocked them."
        description="You can unblock the user by clicking the button below."
        image="/assets/empty-12.png"
      />
      <Button
        onClick={onUnblockUserClick}
        disabled={loading}
        className="w-auto bg-destructive text-white"
      >
        {loading ? "Unblocking..." : `Unblock ${blockedUserDisplayName}`}
      </Button>
    </div>
  );
};
